/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M283.018 317.537l-65.288-67.825L92 319.245l137.847-146.282 65.288 67.825 125.731-69.533-137.847 146.282zM256.432 1C117.018 1 4 106.682 4 237.049c0 74.162 36.577 140.335 93.78 183.609v90.34l86.146-47.784c22.965 6.429 47.304 9.885 72.506 9.885 139.414 0 252.432-105.684 252.432-236.05 0-130.367-113.018-236.05-252.432-236.05z"
      fill="#231F20"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconFbMessenger = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconFbMessenger.defaultProps = {
  theme,
};
IconFbMessenger.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconFbMessenger.displayName = 'IconFbMessenger';
export { IconFbMessenger };
